import React, { useState, useEffect } from 'react'
import { css, useTheme } from '@emotion/react'
import Image from './Image'
import { ProfitOrLossCheck, currencyFormat } from './Utility'
import { Typography, Table, SimplePagination, Link } from './'
import clsx from 'clsx'

function TableCoins({ type = 'full', head }) {
    const theme = useTheme()
    const [items, setItems] = useState({})
    const [loading, setLoading] = useState(true)

    const [from_id, setFrom_id] = useState(null)

    useEffect(() => {
        fetch('/api/graphql', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                query: `{
                    coinsLatest(meta: { limit: 20, from_id: ${from_id ? `"${from_id}"` : 'null'}}) {
                        from_id
                        next_id
                        prev_id
                        data {
                        id
                        logo_path
                        chart_path
                        usd_price
                        market_cap
                        irr_price
                        volume_24h
                        symbol
                        percent_change_1h
                        }
                    }
                }`
            })
        })
            .then((response) => response.json())
            .then(({ data }) => {
                setItems(data.coinsLatest)
                setLoading(false)
            })
    }, [from_id])

    if (loading)
        return (
            <Typography type="h4" color="warning">
                در حال بارگزاری
            </Typography>
        )
    else if (items?.length)
        return (
            <Typography type="h4" color="danger">
                خطا اتفاق افتاده
            </Typography>
        )
    return (
        <>
            <div className="overflow-x-auto">
                <Table head={head}>
                    {items?.data?.map((coin, idx) => (
                        <tr key={idx}>
                            <td>
                                <div
                                    className={clsx('flex items-center px-2', {
                                        'w-40 lg:w-auto': type === 'full'
                                    })}
                                    css={css`
                                        font-family: ${theme.font?.en};
                                    `}
                                >
                                    <Link
                                        href={`/coins/${coin.id}`}
                                        style="span.internal-link { a { display:flex; align-items:center;} }"
                                    >
                                        <Image
                                            noStyle
                                            alt={coin?.id}
                                            src={coin.logo_path}
                                            width={30}
                                            height={30}
                                        />
                                        <span className="mx-1 h-full">
                                            {coin?.id}
                                        </span>
                                    </Link>
                                </div>
                            </td>

                            <td
                                css={css`
                                    font-family: ${theme.font?.en};
                                `}
                            >
                                {currencyFormat(
                                    coin?.usd_price,
                                    'USD',
                                    'us-US'
                                )}
                            </td>
                            <td
                                css={css`
                                    direction: ltr;
                                    font-family: ${theme.font?.en};
                                `}
                            >
                                <div
                                    className={clsx('', {
                                        'w-40 lg:w-auto': type === 'full'
                                    })}
                                >
                                    {coin?.percent_change_1h && (
                                        <ProfitOrLossCheck
                                            percentage={coin?.percent_change_1h.toFixed(
                                                3
                                            )}
                                        />
                                    )}
                                </div>
                            </td>
                            {type === 'full' && (
                                <td
                                    css={css`
                                        direction: ltr;
                                    `}
                                >
                                    {currencyFormat(coin?.irr_price, 'IRR')}
                                </td>
                            )}
                            {type === 'full' && (
                                <td
                                    css={css`
                                        font-family: ${theme.font?.en};
                                    `}
                                >
                                    {currencyFormat(
                                        coin?.volume_24h,
                                        'USD',
                                        'us-US'
                                    )}
                                </td>
                            )}
                            {type === 'full' && (
                                <td
                                    css={css`
                                        font-family: ${theme.font?.en};
                                    `}
                                >
                                    {' '}
                                    {currencyFormat(
                                        coin?.market_cap,
                                        'USD',
                                        'us-US'
                                    )}
                                </td>
                            )}
                            {type === 'full' && (
                                <td>
                                    <div className="w-40 lg:w-auto">
                                        <Image
                                            alt={coin?.id}
                                            src={coin.chart_path}
                                            width={100}
                                            height={30}
                                        />
                                    </div>
                                </td>
                            )}
                        </tr>
                    ))}
                </Table>
            </div>

            {type === 'full' && (
                <SimplePagination
                    next_id={items.next_id}
                    prev_id={
                        items.from_id === items.prev_id ? null : items.prev_id
                    }
                    setFrom_id={setFrom_id}
                />
            )}
        </>
    )
}
export default TableCoins
